export const ROLE_PREVIEW_OPTIONS = [
    {
        key: 'sfeermeester',
        label: 'rolePreview.roles.sfeermeester',
        role: ['Sfeermeester'],
        permissions: [
            'Permissions.Companies.Read',
            'Permissions.Companies.Create',
            'Permissions.Companies.Update',
            'Permissions.Roles.Read',
            'Permissions.Roles.Create',
            'Permissions.Roles.Update',
            'Permissions.Users.Read',
            'Permissions.Users.Create',
            'Permissions.Users.Update',
            'Permissions.VdkEvents.Read',
            'Permissions.VdkEvents.Create',
            'Permissions.VdkEvents.Update',
            'Permissions.VdkTasks.Read',
            'Permissions.VdkTasks.Create',
            'Permissions.VdkTasks.Update',
            'Permissions.VdkPeople.Read',
            'Permissions.VdkPeople.Create',
            'Permissions.VdkPeople.Update',
            'Permissions.Partner.Read',
            'Permissions.Partner.Create',
            'Permissions.Partner.Update',
            'Permissions.Collaborator.Read',
            'Permissions.Collaborator.Create',
            'Permissions.Collaborator.Update',
            'Permissions.ExternalRelation.Read',
            'Permissions.ExternalRelation.Create',
            'Permissions.ExternalRelation.Update',
        ],
    },
    {
        key: 'otheruser',
        label: 'rolePreview.roles.otherUser',
        role: ['OtherUser'],
        permissions: [
            'Permissions.Users.Read',
            'Permissions.Companies.Read',
            'Permissions.Roles.Read',
            'Permissions.VdkTasks.Read',
            'Permissions.VdkPeople.Read',
            'Permissions.VdkEvents.Read',
            'Permissions.Partner.Read',
            'Permissions.Collaborator.Read',
            'Permissions.ExternalRelation.Read',
        ],
    },
    {
        key: 'collaborator-external',
        label: 'rolePreview.roles.supplierExternal',
        role: ['Collaborator'],
        permissions: [
            'Permissions.VdkEvents.Read',
            'Permissions.VdkEvents.Update',
            'Permissions.VdkTasks.Read',
            'Permissions.VdkTasks.Update',
            'Permissions.Users.Read',
        ],
        IsCollaborator: true,
        CollaboratorAccessLevel: 1,
    },
    {
        key: 'collaborator-internal',
        label: 'rolePreview.roles.supplierInternal',
        role: ['Collaborator'],
        permissions: [
            'Permissions.VdkEvents.Read',
            'Permissions.VdkEvents.Update',
            'Permissions.VdkTasks.Read',
            'Permissions.VdkTasks.Update',
            'Permissions.Users.Read',
        ],
        IsCollaborator: true,
        CollaboratorAccessLevel: 0,
    },
    {
        key: 'transport-internal',
        label: 'rolePreview.roles.transportInternal',
        role: ['TransportManager'],
        permissions: [
            'Permissions.VdkEvents.Read',
            'Permissions.VdkEvents.Update',
            'Permissions.VdkTasks.Read',
            'Permissions.VdkTasks.Update',
            'Permissions.Users.Read',
        ],
        IsCollaborator: true,
        CollaboratorAccessLevel: 0,
    },
    {
        key: 'transport-external',
        label: 'rolePreview.roles.transportExternal',
        role: ['TransportManager'],
        permissions: [
            'Permissions.VdkEvents.Read',
            'Permissions.VdkEvents.Update',
            'Permissions.Users.Read',
        ],
        IsCollaborator: true,
        CollaboratorAccessLevel: 1,
    },
];
